import LegacySocialBar from './LegacySocialBar';

export * from './LegacySocialBar';

export default LegacySocialBar;
